import { lifestyleCards } from "@/mocks/home";

export default function Lifestyle() {
  return (
    <section id="lifestyle" className="w-full bg-background-950 py-14 md:py-24 text-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
          <div>
            <span className="inline-block font-heading tracking-[0.32em] text-xs font-semibold text-primary-400">
              RIDE LIFESTYLE
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold leading-tight tracking-tight">
              라이더의 하루,<br />모든 순간에 함께.
            </h2>
          </div>
          <p className="max-w-md text-background-200 text-base leading-relaxed">
            도심 출근, 주말 투어링, 배달 라이딩, 밤의 몰입. X9 PRO는 상황에 맞춰
            소리와 연결을 조율합니다.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {lifestyleCards.map((c) => (
            <article
              key={c.id}
              className="relative group rounded-xl overflow-hidden h-[380px] md:h-[440px] cursor-pointer"
            >
              <img
                src={c.image}
                alt={c.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-950/10 via-background-950/30 to-background-950/85"></div>
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 leading-tight">
                  {c.title}
                </h3>
                <p className="mt-2 text-sm text-background-100/90">
                  {c.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}